module.exports = {"422828100":"走马镇","422828101":"容美镇","422828102":"太平镇","422828103":"燕子镇","422828104":"中营镇","422828200":"铁炉乡","422828201":"五里乡","422828203":"下坪乡","422828204":"邬阳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422828.json
// module id = 1923
// module chunks = 0